import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import Modal from '@material-ui/core/Modal';
import React from 'react';
import { useAppSelector } from '../../../store';


export default function ModalCreateActions(props: any) {
    const { words } = useAppSelector(state => state.localization);

    const handleClose = () => {
        props.setOpen(false);
    };

    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className="modal-06"
            open={props.open}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
            onClose={handleClose}>
            <Fade in={props.open}>
                <div className="modal-content">
                    <svg className="icon"
                        width="102"
                        height="103"
                        viewBox="0 0 102 103"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M51 94C74.4727 94 93.5 74.9727 93.5 51.5C93.5 28.0273 74.4727 9 51 9C27.5273 9 8.5 28.0273 8.5 51.5C8.5 74.9727 27.5273 94 51 94Z"
                            stroke="#00A3FF"
                            strokeWidth="5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M38.25 51.5L46.75 60L63.75 43"
                            stroke="#00A3FF"
                            strokeWidth="5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>

                    <p className="title" id="transition-modal-description">
                        {props.message}
                    </p>
                    <div className="button-wrap" onClick={handleClose}>

                        <button className="button-02" type="button" onClick={handleClose}>
                            {words && words['WEB.ok']}
                        </button>




                    </div>
                </div>
            </Fade>
        </Modal>
    );
}
